import React, {useEffect} from 'react';
import {makeStyles} from "@material-ui/core/styles";
import AppBar from "../Components/AppBar";
import SubHeader from "../Components/SubHeader";
import Container from "@material-ui/core/Container";
import {isElitefoto, useAPI} from "../../../lib/common";
import {Trans, useTranslation} from "react-i18next";
import {Link} from "react-router-dom";

const useStyles = makeStyles(theme => {
    return {
        categoryList: {
            margin: 0,
            padding: 0,
            listStyle: 'none',
            display: 'grid',
            [theme.breakpoints.up('xs')]: {
                gridTemplateColumns: 'repeat(1, 1fr)',
            },
            [theme.breakpoints.up('sm')]: {
                gridTemplateColumns: 'repeat(3, 1fr)',
            },
            [theme.breakpoints.up('lg')]: {
                gridTemplateColumns: 'repeat(4, 1fr)',
            },
            gridGap: theme.spacing(2),
            '& > li': {
                paddingBottom: '100%',
                position: 'relative',
                [theme.breakpoints.down('xs')]: {
                    flexBasis: '50%'
                },
                backgroundColor: '#fefefe'
            }
        },
        container: {
            position: 'absolute',
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'white',
            color: 'black',
            textDecoration: 'none',
            display: 'flex',
            flexDirection: 'column',
            boxShadow: '0px 3px 6px #00000029'
        },
        imageContainer: {
            paddingTop: '67%',
            position: 'relative',
            flexShrink: 0,
            '& > img': {
                position: 'absolute',
                left: 0,
                top: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover'
            }
        },
        description: {
            padding: '4px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            flexGrow: 1,
            '& h3': {
                textTransform: 'uppercase',
                margin: 0,
                textAlign: 'center'
            },
            '& p': {
                margin: 0,
                textAlign: 'center',
                fontSize: '15px'
            }
        }
    }
});


export default() => {
    const [req, loadingCategories] = useAPI('/m/api/products/categories');
    const classes = useStyles();
    const [t] = useTranslation();

    useEffect(() => {
        if (isElitefoto()) {
            document.location.href = 'https://www.elitefoto.no/fotogaver/';
        }
    },[]);

    if (loadingCategories) {
        return <div>
            <Trans>Loading</Trans>
        </div>
    }

    return <React.Fragment>
        <AppBar disableGutters/>
        <SubHeader title={t('Categories')} />
        <Container>
            <ul className={classes.categoryList}>
            {req.categories.map(category => {
                let LinkElm = 'a';
                let attrs = {
                    href: category.link
                };

                if (['CARDS', 'CALENDARS'].indexOf(category.type) >= 0) {
                    LinkElm = Link;
                    attrs = {
                        to: `/products/${category.type.toLowerCase()}`
                    };
                }
                else if (category.type == 'PHOTOGIFT') {
                    LinkElm = Link;
                    attrs = {
                        to: `/products/${category.type.toLowerCase()}/${category.category.toUpperCase()}`
                    };
                }
                else if (category.type == 'PAPER_COPIES') {
                    LinkElm = Link;
                    attrs = {
                        to: `/upload`
                    };
                }

                return <li key={category.category}>
                    <LinkElm className={classes.container} {...attrs} >
                        <div className={classes.imageContainer}>
                            <img src={category.image}/>
                        </div>
                        <div className={classes.description}>
                            <h3>{category.title}</h3>
                            <p>{category.description}</p>
                        </div>
                    </LinkElm>
                </li>
            })}
            </ul>
        </Container>
    </React.Fragment>
}
